import { message, Row, Col, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  InputItem,
  ButtonItem,
  ErrorItem,
  SelectItem,
  SwitchItem,
  SelectEmpleadosItem,
} from "../../../../Components/Items";

const { Option } = Select;

class EditarEtapa extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    etapasOptions: null,
    todasEtapasAnteriores: [],
    todasEtapasSiguientes: [],
    datosIniciales: null,
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      this.cargarDatosEtapa();
    }
    if (prevProps.visible && !this.props.visible) {
      this.limpiarDatos();
    }
  }

  cargarDatosEtapa = () => {
    if (!this.props.etapaId) {
      message.error("No se proporcionó ID de etapa para editar");
      return;
    }

    this.setState({ loading: true });

    axios
      .post(
        "etapas/obtenerEtapa",
        {
          etapaId: this.props.etapaId,
          empresaId: this.props.empresaId,
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const etapa = res.data.etapa;

          if (etapa) {
            this.setState({ datosIniciales: etapa });

            this.formRef.current?.setFieldsValue({
              ...etapa,
              nombre: etapa.nombre,
              descripcion: etapa.descripcion,
              etapaAnterior: etapa.etapaAnterior || [],
              etapaSiguiente: etapa.etapaSiguiente || [],
            });

            this.consultarEtapas();
          } else {
            this.setState({ loading: false });
            message.error("No se pudieron cargar los datos de la etapa");
          }
        } else {
          this.setState({ loading: false });
          message.error("Error al cargar los datos de la etapa");
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.error("Error al cargar la etapa:", error);
        message.error("Error al cargar los datos de la etapa");
      });
  };

  consultarEtapas = () => {
    axios
      .post(
        "etapas/selectTodasEtapas",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });

        if (res.data.success === 2) {
          const etapasFiltradas = res.data.etapas.filter(
            (etapa) => etapa._id !== this.props.etapaId
          );

          const options = etapasFiltradas.map((etapa) => (
            <Option key={etapa._id} value={etapa._id}>
              {etapa.nombre}
            </Option>
          ));

          this.setState({
            etapasOptions: options,
            todasEtapasAnteriores: options,
            todasEtapasSiguientes: options,
          });
        } else {
          message.error("Error al cargar las opciones de etapas");
        }

      })
      .catch((error) => {
        this.setState({ loading: false });
        console.error("Error al consultar etapas:", error);
        message.error("Error al cargar las opciones de etapas");
      });
  };

  limpiarDatos = () => {
    this.setState({
      etapasOptions: null,
      todasEtapasAnteriores: [],
      todasEtapasSiguientes: [],
      datosIniciales: null,
    });
    this.formRef.current?.resetFields();
  };

  cerrarEditarEtapa = (codigo = null) => {
    this.props.cerrarModal(codigo);
  };

  onFinishFailed = (e) => {
    ErrorItem(e);
  };

  onFinish = (values) => {
    if (!this.props.etapaId) {
      message.error("No se puede actualizar: ID de etapa no válido");
      return;
    }

    this.setState({ loading: true });

    axios
      .post(
        "etapas/editarEtapa",
        {
          ...values,
          etapaId: this.props.etapaId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });

        if (res.data.success === 2) {
          const etapaActualizada = res.data.etapa;

          if (etapaActualizada && etapaActualizada._id) {
            message.success("Etapa actualizada correctamente");
            this.cerrarEditarEtapa(etapaActualizada._id);
          } else {
            message.error("Ocurrió un error al actualizar");
          }
        } else {
          message.error("Error al actualizar la etapa");
        }

      })
      .catch((err) => {
        this.setState({ loading: false });
        console.error(err);
        message.error("Error al conectar con el servidor");
      });
  };

  // Taxidermia: la etapa se controla por persona en el Dashboard (tablero "Por persona" y
  // reporte semanal). `personal` son los empleados que la trabajan. Mismo bloque que AgregarEtapa.
  renderControlPorPersona() {
    return (
      <>
        <FormItem
          name="controlPorPersona"
          label="Controlar trabajo por persona"
          margin
          tooltip="Cada pieza de esta etapa se asigna a una persona (montador, retocador...) desde el Dashboard, con fecha de inicio y de término, y sale en el reporte semanal de producción"
          valuePropName="checked"
        >
          <SwitchItem />
        </FormItem>
        <FormItem shouldUpdate noStyle>
          {({ getFieldValue }) =>
            getFieldValue("controlPorPersona") ? (
              <FormItem
                name="personal"
                label="Personal de la etapa"
                margin
                tooltip="Las personas que salen como columnas en el tablero por persona"
              >
                <SelectEmpleadosItem
                  empresaId={this.props.empresaId}
                  headersToken={this.props.headersToken}
                  sinBorde
                  width="100%"
                  mode="multiple"
                  placeholder="Empleados que trabajan esta etapa"
                />
              </FormItem>
            ) : null
          }
        </FormItem>
      </>
    );
  }

  render() {
    return (
      <ModalItem
        title="Editar Etapa"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={() => this.cerrarEditarEtapa()}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="EditarEtapa"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
            >
              Editar
            </ButtonItem>
          }
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
        >
          <Row style={{ width: "100%" }}>
            <Col span={24}>
              <FormItem
                name="nombre"
                label="Nombre"
                required
                max={100}
                margin
                pattern
              >
                <InputItem placeholder="Nombre" />
              </FormItem>
              <FormItem
                name="descripcion"
                label="Descripción"
                margin
                pattern
                required
              >
                <InputItem placeholder="Descripción" />
              </FormItem>
              <FormItem
                name="etapaAnterior"
                label="Etapa Anterior"
                margin
              >
                <SelectItem mode="multiple" placeholder="Selecciona la etapa anterior">
                  {this.state.todasEtapasAnteriores}
                </SelectItem>
              </FormItem>
              <FormItem
                name="etapaSiguiente"
                label="Etapa Siguiente"
                margin
              >
                <SelectItem mode="multiple" placeholder="Selecciona la etapa siguiente">
                  {this.state.todasEtapasSiguientes}
                </SelectItem>
              </FormItem>
              <FormItem
                name="editarAlEntrar"
                label="Editar al entrar"
                margin
                tooltip="Si se activa, al entrar a esta etapa se abrirá el formulario de edición"
                valuePropName="checked"
              >
                <SwitchItem />
              </FormItem>
              <FormItem shouldUpdate noStyle>
                {({ getFieldValue }) => {
                  const editarAlEntrar = getFieldValue("editarAlEntrar");

                  if (!editarAlEntrar) return null;

                  // Lista de campos para evitar repetición
                  const campos = [
                    { nombre: "Observaciones", label: "Editar observaciones" },
                  ];

                  if (this.props.taxidermia) {
                    campos.push(
                      { nombre: "Empleados", label: "Editar empleados" },
                      { nombre: "FormaVentaId", label: "Editar Venta" },
                      { nombre: "FechaEntrega", label: "Editar Fecha de entrega" },
                      { nombre: "Posicion", label: "Editar posición" },
                      { nombre: "Talla", label: "Editar talla" },
                    );
                  }

                  return (
                    <Row gutter={16}>
                      {campos.map((campo) => {
                        const editarKey = `editar${campo.nombre}`;
                        const requeridoKey = `editar${campo.nombre}Requerido`;
                        const isEditable = getFieldValue(editarKey);

                        return (
                          <Col span={24} key={campo.nombre}>
                            <Row align="middle" gutter={12}>
                              <Col span={12}>
                                <FormItem
                                  name={editarKey}
                                  label={campo.label}
                                  margin
                                  labelCol={{ span: 16 }}
                                  wrapperCol={{ span: 8 }}
                                  valuePropName="checked"
                                >
                                  <SwitchItem />
                                </FormItem>
                              </Col>
                              <Col span={12}>
                                {isEditable && (
                                  <FormItem
                                    name={requeridoKey}
                                    label="¿Requerido?"
                                    valuePropName="checked"
                                    margin
                                  >
                                    <SwitchItem />
                                  </FormItem>
                                )}
                              </Col>
                            </Row>
                          </Col>
                        );
                      })}
                    </Row>
                  );
                }}
              </FormItem>
              {this.props.taxidermia && this.renderControlPorPersona()}
            </Col>
          </Row>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  taxidermia: state.empresa.taxidermia,
});

export default connect(mapStateToProps)(EditarEtapa);
